import React from "react";
import {
  MdWidgets,
  MdViewQuilt,
  MdQueueMusic,
  MdPlaylistAdd,
  MdConfirmationNumber,
  MdAddCircleOutline,
  MdShowChart,
  MdPlaylistPlay,
  MdAndroid,
  MdExtension
} from "react-icons/md";

import queryString from "./utils/queryString";

export const api = {
  baseURL: process.env.REACT_APP_BASE_API_URL,
  endpoints: {
    captcha: '/public/user/captcha',
    login: '/public/user/login',
    logout: '/user/management/logout',
    tags: '/admin/channel/automatic/tag/list',
    search: type => {
      if (type === 'user') return `/admin/common/user/list`;
      return `/public/channel/search/${type}`;
    },
    tracks: (text, page = 1, size = 30) =>
      `/public/channel/search/track?text=${text}&page=${page}&size=${size}`,
    artists: (text, page = 1, size = 30) =>
      `/public/channel/search/artist?text=${text}&page=${page}&size=${size}`,
    albums: (text, page = 1, size = 30) =>
      `/public/channel/search/album?text=${text}&page=${page}&size=${size}`,
    users: (text, queryType) =>
      `/admin/common/user/list?${queryType}=${text}`,
    tracksById: ids => `/public/channel/filter/track?id=${ids.toString()}`,
    tracksByTags: '/admin/channel/filter/tracks',
    channels: {
      list: {
        automatic: '/admin/channel/automatic/list',
        promoted: '/admin/channel/promoted/list',
        live: '/admin/channel/live/list',
        all: '/admin/channel/list'
      },
      remove: {
        AUTOMATIC_CHANNEL: '/admin/channel/automatic/delete',
        PROMOTED_CHANNEL: '/admin/channel/promoted/delete',
        LIVE_CHANNEL: '/admin/channel/live/delete'
      },
      add: {
        AUTOMATIC_CHANNEL: '/admin/channel/automatic/add',
        PROMOTED_CHANNEL: '/admin/channel/promoted/add',
        LIVE_CHANNEL: '/admin/channel/live/add'
      },
      get: id => `/admin/channel/get?id=${id}`,
      search: (text, page = 1, size = 30) =>
        `/public/channel/search/channel?text=${text}&page=${page}&size=${size}`
    },
    app: {
      forcUpdate: {
        list: '/admin/common/mobile/version/list',
        update: '/admin/common/mobile/version/update'
      }
    },
    ads: {
      list: channelId => channelId ? `/admin/channel/system/advertise/get?channelId=${channelId}` : '/admin/channel/advertise/list',
      get: id => `/admin/channel/advertise/get?id=${id}`,
      save: '/admin/channel/advertise/add',
      saveSpec: '/admin/channel/advertise/spec/update',
      remove: '/admin/channel/advertise/delete',
      getSpecs: id => `/admin/channel/advertise/spec/get?advertiseId=${id}`
    },
    home: {
      getChannelItems: `/admin/channel/item/get`,
      addChannelItems: `/admin/channel/item/add`,
      addItemImages: `/admin/channel/item/image/add`
    },
    report: {
      user: {
        register: ({ startDate, endDate }) =>
          `/admin/channel/report/user/info?startDate=${startDate}&endDate=${endDate}`
      },
      recommender: {
        analysis: ({ startDate, endDate, id, type, loginState }) =>
          `/admin/channel/report/recommender/analysis?startDate=${startDate}&endDate=${endDate}&type=${type}&loginState=${loginState}${
          id ? `&id=${id}` : ''
          }`
      },
      offline: ({ startDate, endDate }) => `/admin/channel/report/offline/general?startDate=${startDate}&endDate=${endDate}`,
      ads: ({ startDate, endDate, advertiseId }) => `/admin/channel/report/advertise/${advertiseId ? 'specific' : 'general'}?${queryString({
        startDate,
        endDate,
        advertiseId
      })}`
    },
    mediums: {      
      home:{
        list: '/admin/channel/media/item/list',
        single:{
          get: medium=>`/admin/channel/media/item/get?media=${medium}`,
          add: '/admin/channel/media/item/add'
        }
      }
    }
  }
}
export const menuItems = [
  { text: 'داشبورد', to: '/', icon: <MdWidgets /> },
  {
    text: 'چینش کانال‌ها',
    to: '/layout',
    icon: <MdViewQuilt />,
    subItems:[
      {
        text: 'شافل',
        to: '/layout',
        icon: <MdViewQuilt />
      },
      {
        text: 'سایر برنامه‌ها',
        to: '/layout/mediums',
        icon: <MdExtension />
      }
    ]
  },
  {
    text: 'کانال‌ها',
    to: '/channels',
    icon: <MdQueueMusic />,
    subItems: [
      { text: 'لیست کانال‌ها', to: '/channels', icon: <MdQueueMusic /> },
      {
        text: 'افزودن کانال',
        to: '/channels/new',
        icon: <MdPlaylistAdd />
      }
    ]
  },
  {
    text: 'مدیریت تبلیغات',
    to: '/ads',
    icon: <MdConfirmationNumber />,
    subItems: [
      { text: 'لیست تبلیغات', to: '/ads', icon: <MdConfirmationNumber /> },
      {
        text: 'افزودن تبلیغ',
        to: '/ads/new',
        icon: <MdAddCircleOutline />
      },
      {
        text: 'گزارش تبلیغات',
        to: '/ads/reports',
        icon: <MdShowChart />
      }
    ]
  },
  {
    text: 'آنالیز محتوا',
    to: '/reports/analysis',
    icon: <MdPlaylistPlay />
  },
  { text: 'تنظیمات اپلیکیشن', to: '/app-setting', icon: <MdAndroid /> },
]